import React, { useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { CheckCircle2, TrendingUp, Users, ClipboardList } from "lucide-react";

const Partner = () => {
  const { t } = useLang();
  const [form, setForm] = useState({
    restaurant_name: "", contact_name: "", phone: "", email: "", cuisine: "", address: "", message: "",
  });
  const [sent, setSent] = useState(false);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = async () => {
    for (const k of ["restaurant_name", "contact_name", "phone", "email"]) {
      if (!form[k]) { toast.error(t("fillRequired")); return; }
    }
    try {
      await api.post("/partner-requests", form);
      setSent(true);
      toast.success("Request sent!");
    } catch { toast.error("Failed to send"); }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-navy tracking-tight">{t("partnerTitle")}</h1>
      <p className="mt-3 text-navy/70 max-w-xl">{t("partnerText")}</p>

      <div className="mt-10 grid md:grid-cols-3 gap-4">
        {[{ icon: TrendingUp, text: "More visibility" }, { icon: Users, text: "Tourist-focused platform" }, { icon: ClipboardList, text: "Simple order management" }].map((b, i) => (
          <div key={i} className="p-5 rounded-2xl bg-white border border-navy/10">
            <b.icon className="w-6 h-6 text-coral mb-2" />
            <div className="font-heading font-bold text-navy">{b.text}</div>
          </div>
        ))}
      </div>

      <div className="mt-10 bg-white rounded-2xl border border-navy/10 p-6">
        <h2 className="font-heading font-bold text-navy text-xl mb-4">{t("becomePartner")}</h2>
        {sent ? (
          <div className="text-center py-8" data-testid="partner-success">
            <CheckCircle2 className="w-12 h-12 text-teal mx-auto" />
            <p className="mt-3 font-heading text-navy text-lg">Thanks! We'll be in touch soon.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-3">
            <div><Label>Restaurant name*</Label><Input value={form.restaurant_name} onChange={e => set("restaurant_name", e.target.value)} data-testid="partner-restaurant-name" /></div>
            <div><Label>Contact name*</Label><Input value={form.contact_name} onChange={e => set("contact_name", e.target.value)} data-testid="partner-contact-name" /></div>
            <div><Label>Phone*</Label><Input value={form.phone} onChange={e => set("phone", e.target.value)} data-testid="partner-phone" /></div>
            <div><Label>Email*</Label><Input type="email" value={form.email} onChange={e => set("email", e.target.value)} data-testid="partner-email" /></div>
            <div><Label>Cuisine</Label><Input value={form.cuisine} onChange={e => set("cuisine", e.target.value)} data-testid="partner-cuisine" /></div>
            <div><Label>Address</Label><Input value={form.address} onChange={e => set("address", e.target.value)} data-testid="partner-address" /></div>
            <div className="sm:col-span-2"><Label>Message</Label><Textarea value={form.message} onChange={e => set("message", e.target.value)} data-testid="partner-message" /></div>
            <div className="sm:col-span-2">
              <Button onClick={submit} className="btn-coral" data-testid="partner-submit">{t("becomePartner")}</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Partner;
